import { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { IoSwapVertical } from 'react-icons/io5';

export default function TRCSortModal({ filters, containsPdf }) {
	const [show, setShow] = useState(false);
	const { sortby, handleFilterChange } = filters;
	const handleOpen = () => setShow(true);
	const handleClose = () => setShow(false);

	return (
		<>
			<div
				className="d-flex align-items-center gap-1 d-lg-none"
				style={{
					padding: '0.5rem',
					border: '0.06rem solid #3CB4E4',
					borderRadius: '0.5rem'
				}}
				onClick={handleOpen}
			>
				<IoSwapVertical size={24} color="#3CB4E4" />
				<span className="sr-only">Sort by</span>
			</div>
			<Modal show={show} onHide={handleClose} centered>
				<Modal.Header closeButton>
					<Modal.Title>Sort By</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Form.Select className="filterby" onChange={handleFilterChange} value={sortby}>
						<option value="latest">Newest</option>
						<option value="oldest">Oldest</option>
						<option value="title_asc">Title (A - Z)</option>
						<option value="title_desc">Title (Z - A)</option>
						{!containsPdf && (
							<>
								<option value="long_duration">Longest</option>
								<option value="short_duration">Shortest</option>
							</>
						)}
					</Form.Select>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={handleClose}>
						Close
					</Button>
				</Modal.Footer>
			</Modal>
		</>
	);
}
